import { VEHICLES_LIST, ADD_VEHICLE, UPDATE_VEHICLE, LOADING, NOT_FOUND,ADD0N_VEHICLES_LIST } from "../action/type";

const initialState = {
  list: [{}],
  loading:false,
  not_found:false
};
const vehicles = function (state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return { ...state, list: action.payload ,loading:true,not_found:false};
    case NOT_FOUND:
      return { ...state, list: action.payload ,loading:false,not_found:true};
    case VEHICLES_LIST:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    case ADD_VEHICLE:
      return { ...state, list: action.payload ,loading:false,not_found:false};
      case ADD0N_VEHICLES_LIST : 
      return {...state,list:action.payload,loading:false,not_found:false}
    case UPDATE_VEHICLE:
      return { ...state, list: action.payload ,loading:false,not_found:false};
    default:
      return state;
  }
};

export default vehicles;
